import React, { useRef, useState, useEffect } from 'react';
import * as cls from './awards.module.css';
import { IMG_PATH } from '../../../constants';
import { Typography } from '../../../ui/components/typography/typography';

const awards = [
  {
    img: `${IMG_PATH}/home/awards/brazil-tech-award.png`,
    alt: 'brazil tech award',
  },
  {
    img: `${IMG_PATH}/home/awards/startup-energy-transition-2020.png`,
    alt: 'startup energy transition 2020',
  },
  {
    img: `${IMG_PATH}/home/awards/clean-equity-monaco-2021.png`,
    alt: 'clean equity monaco 2021',
  },
  {
    img: `${IMG_PATH}/home/awards/advancing-low-carbon.png`,
    alt: 'advancing low carbon',
  },
  {
    img: `${IMG_PATH}/home/awards/solar-impulse-2022.png`,
    alt: 'solar impulse 2022',
  },
  {
    img: `${IMG_PATH}/home/awards/one-clear-winner.png`,
    alt: 'one clear winner',
  },
  {
    img: `${IMG_PATH}/home/awards/greentown-labs.png`,
    alt: 'green town labs',
  },
  {
    img: `${IMG_PATH}/home/awards/best-products-reviews.png`,
    alt: 'best products reviews',
  },
];

export const Awards = () => {
  const sectionRef = useRef(null);
  const [animatedItems, setAnimatedItems] = useState(new Set());

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const images = sectionRef.current?.querySelectorAll('img');
          if (images) {
            images.forEach((image, index) => {
              setTimeout(() => {
                setAnimatedItems((prev) => new Set(prev).add(index));
              }, index * 120); // 120ms delay between each image
            });
          }
        }
      },
      {
        threshold: 0.4,
        rootMargin: '-50px 0px',
      },
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  return (
    <div ref={sectionRef}>
      <Typography className={cls.title} tag="h2">
        AWARDS
      </Typography>
      <div className={cls.awards}>
        {awards.map((award, index) => (
          <img
            key={index}
            src={award.img}
            alt={award.alt}
            className={animatedItems.has(index) ? cls.animated : cls.hidden}
          />
        ))}
      </div>
    </div>
  );
};
